import React, { useEffect } from "react"
import PropTypes from "prop-types"

import Header from "./header"
import BreadCrumbs from "@one-builder/gatsby-theme-ob-master/src/components/layout/breadcrumbs"
import StickyCta from "@one-builder/gatsby-theme-ob-master/src/components/layout/sticky-cta"
import SEO from "@one-builder/gatsby-theme-ob-master/src/components/layout/seo"
import getBreadCrumbs from "@one-builder/gatsby-theme-ob-master/src/helpers/getBreadCrumbs"
import { useGetTokens } from "@one-builder/gatsby-theme-ob-master/src/hooks/useGetTokens"
import convertTokens from "@one-builder/gatsby-theme-ob-master/src/helpers/convertTokens"

import Footer from "./footer"

const Layout = ({ children, location, seo_data = {} }) => {
  // Add homepage or subpage to body tag
  useEffect(() => {
    let body
    if (document) {
      body = document.getElementsByTagName("body")[0]
      if (location) {
        body ? body.setAttribute("id", "subpage") : body.setAttribute("id", "")
      } else {
        body ? body.setAttribute("id", "homepage") : body.setAttribute("id", "")
      }
    }
  }, [location])

  // If location passed to layout, set breadcrumbs
  let breadcrumbs
  if (location) {
    breadcrumbs = getBreadCrumbs(location)
  } else {
    breadcrumbs = undefined
  }

  // Get meta data
  const metadata = useGetTokens()

  return (
    <>
      <SEO
        metadata={metadata}
        seo_data={convertTokens(JSON.stringify(seo_data), metadata)}
        location={location}
      />
      <Header metadata={metadata} />
      {breadcrumbs ? <BreadCrumbs breadcrumbs={breadcrumbs} /> : null}
      <main>{children}</main>
      <StickyCta />
      <Footer metadata={metadata} />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
